"use client";

import { useEffect } from "react";
import { updateLastActive } from "@/app/actions/activity";

export function ActivityTracker() {
  useEffect(() => {
    updateLastActive();
  }, []);
  return null;
}
